import { ReactElement, useCallback, useMemo } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useEventCallback } from '@mui/material';
import {
  createSearchParams,
  generatePath,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import SipoPersonForm from 'shell/components/shared/sipo-person-form';
import PmiTitle from 'shell/components/shared/title';
import { __PERSON_API_URL__, __PERSON_NEW_API_URL__ } from 'shell/constants/environment';
import { CitizenshipNewCrumbs } from 'subscription/constants/breadcrumb';
import { SubjectData } from 'shell/models/person';

const PersonSipoCitizenshipNewPage = (): ReactElement => {
  const navigate = useNavigate();

  const [queryParams] = useSearchParams();

  const stateRequestApplicant = useLocation().state as {
    accountHolderFiscalCode: string | undefined;
  };

  // id intestatrio se presente fare get perchè siamo in modifica
  const idIntestatario = queryParams.get('idIntestatario') || '';
  const idAnpr = queryParams.get('idAnpr') || '';
  const fiscalCode = queryParams.get('codiceFiscale') || '';

  const isEdit = useMemo(() => {
    if ((idIntestatario && idIntestatario !== '0') || (idAnpr && idAnpr !== '0')) {
      return true;
    }

    return false;
  }, [idIntestatario, idAnpr]);

  const handleOnSuccess = useEventCallback(
    (newIdIntestatario?: string, state?: { subjectData?: SubjectData }) => {
      if (isEdit) {
        navigate(
          {
            pathname: generatePath('/iscrizioni/aire-cittadinanza-nuova'),
            search: `?${createSearchParams({
              idIntestatario: newIdIntestatario || idIntestatario || '',
              idAnpr: idAnpr || '',
              codiceFiscale: fiscalCode,
            })}`,
          },
          {
            state: stateRequestApplicant,
          }
        );

        return;
      }

      navigate(
        {
          pathname: generatePath('/iscrizioni/aire-cittadinanza-nuova'),
          search: `?${createSearchParams({
            idIntestatario: newIdIntestatario || idIntestatario || '',
            idAnpr: idAnpr || '',
            codiceFiscale: fiscalCode,
          })}`,
        },
        {
          state: { ...stateRequestApplicant, ...state },
        }
      );
    }
  );

  const handleExit = useCallback(() => {
    navigate('/iscrizioni/aire-cittadinanza-nuova');
  }, []);

  return (
    <>
      <Breadcrumbs
        items={[
          ...CitizenshipNewCrumbs,
          {
            name: isEdit ? 'Modifica persona' : 'Nuova persona',
          },
        ]}
      />
      <PmiTitle title={isEdit ? 'Modifica persona' : 'Nuova persona'} />
      <SipoPersonForm
        onExit={handleExit}
        onSuccess={handleOnSuccess}
        urlGetData={
          idIntestatario && idIntestatario !== '0'
            ? `${__PERSON_API_URL__}/non-residenti/sipo/soggetto/${idIntestatario}`
            : `${__PERSON_NEW_API_URL__}/persona`
        }
        fiscalCode={fiscalCode}
        urlRegistration={`${__PERSON_API_URL__}/non-residenti/registrazione-aire`}
        urlUpdate={`${__PERSON_API_URL__}/non-residenti/modifica`}
      />
    </>
  );
};

PersonSipoCitizenshipNewPage.displayName = 'Person Sipo citizenship new Edit Page component';

export default PersonSipoCitizenshipNewPage;
